import React from "react";
import { StaffViewer } from "@/components/StaffViewer";

const VALUES = [
  { stage: 2, name: "Semibreve", beats: "4 beats", note: { pitch: "B4", duration: "whole" }, look: "No stem, not coloured in" },
  { stage: 3, name: "Minim", beats: "2 beats", note: { pitch: "B4", duration: "half" }, look: "Stem, not coloured in" },
  { stage: 3, name: "Crotchet", beats: "1 beat", note: { pitch: "B4", duration: "quarter" }, look: "Stem, coloured in" },
  { stage: 4, name: "Dotted minim", beats: "3 beats", note: { pitch: "B4", duration: "half", dot: true }, look: "Minim with a dot" },
  { stage: 4, name: "Quaver", beats: "½ beat", note: { pitch: "B4", duration: "eighth" }, look: "Coloured in, stem and a tail" },
];

export const NoteValueLadder = ({ stage, testId = "note-value-ladder" }) => {
  const known = VALUES.filter((v) => v.stage <= stage);
  return (
    <div className="mt-5 rounded-2xl border border-border bg-card p-4" data-testid={testId}>
      <p className="font-mono text-[11px] uppercase tracking-widest text-primary">Note values you know so far</p>
      <div className="mt-3 overflow-x-auto">
        <StaffViewer clef="treble" notes={known.map((v) => ({ ...v.note, label: v.name, color: v.stage === stage ? "#F59E0B" : undefined }))} width={Math.max(260, known.length * 110)} showLabels playOnClick={false} testId={`${testId}-staff`} />
      </div>
      <ul className={`mt-3 grid gap-2 ${known.length > 1 ? "sm:grid-cols-2" : ""}`}>
        {known.map((v) => (
          <li key={v.name} className={`flex items-center justify-between rounded-xl border px-3 py-2 text-sm ${v.stage === stage ? "border-primary bg-primary/10" : "border-border"}`} data-testid={`${testId}-${v.name.toLowerCase().replace(" ", "-")}`}>
            <span><strong>{v.name}</strong> <span className="text-muted-foreground">· {v.look}</span></span>
            <span className="font-mono text-xs text-primary">{v.beats}{v.stage === stage ? " · new" : ""}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
